import { afterNextRender, Component, ElementRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';

@Component({
  selector: 'app-secondary-page',
  standalone: true,
  imports: [],
  templateUrl: './secondary-page.component.html',
  styleUrl: './secondary-page.component.scss'
})
export class SecondaryPageComponent implements OnInit {
  private SCROLL_OFFSET_Y = 190.5;
  private activatedRoute = inject(ActivatedRoute);
  private type?: string;
  private componentEle: ElementRef;

  constructor(ele: ElementRef) {
    this.componentEle = ele;

    afterNextRender(() => {
      window.scrollTo(0, 0);
      this.activatedRoute.params.pipe(map((p) => p['type'])).subscribe(t => {
        this.type = t;
        const sectionEle = this.componentEle.nativeElement.querySelector(`#${t}`);
        const sectionScrollY = sectionEle.getBoundingClientRect().top;
        window.scrollTo({left: 0, top: sectionScrollY - this.SCROLL_OFFSET_Y, behavior: 'smooth'});
      });
    });
  }
  ngOnInit(): void {
    this.activatedRoute.params.pipe(map((p) => p['type'])).subscribe(t => {
      this.type = t;

    });
  }
}
